// import React from "react";
import "./EventOneVenue.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const Venue = () => {
  const options = {
    items: 3,
    dots: false,
    loop: true,
    margin: 30,
    nav: true,
    smartSpeed: 1500,
    autoplay: true,
    autoplayTimeout: 5000,
    responsive: {
      // Define breakpoints and the number of items to show at each breakpoint
      0: {
        items: 2,
        nav: false,
      },
      768: {
        items: 3,
        nav: false,
      },
      992: {
        items: 4,
      },
      1199: {
        items: 6,
      },
    },
  };
  return (
    <div className="event_one_venue">
      <div className="container">
        <div className="venue_inner">
          <div className="event_one_venue_section_header">
            <div className="venue_left">
              <div className="icon-main">
                <div className="icon">
                  <span className="music-icon material-symbols-outlined">
                    pin_drop
                  </span>
                </div>
              </div>
              <div>
                <h2 className="title">Venues</h2>
              </div>
            </div>
            <div className="venue_right">
              <button className="event_one_viewall_button">View All</button>
            </div>
          </div>
          <div className="event-container_venue">
            <OwlCarousel className="owl-theme my_owl_carousel" {...options}>
              <div className="item event-card_venue">
                <div className="image-container_venue">
                  <img
                    src="./assets/img/eventify/venue1.jpeg"
                    className="event-image_venue"
                  />
                </div>
                <h5 className="contain_venue_name">Lord's Cricket Ground </h5>
              </div>

              <div className="item event-card_venue">
                <div className="image-container_venue">
                  <img
                    src="./assets/img/eventify/venue2.jpeg"
                    className="event-image_venue"
                  />
                </div>
                <h5 className="contain_venue_name">Madison Square Garden </h5>
              </div>

              <div className="item event-card_venue">
                <div className="image-container_venue">
                  <img
                    src="./assets/img/eventify/venue3.jpeg"
                    className="event-image_venue"
                  />
                </div>
                <h5 className="contain_venue_name">Wimbledon </h5>
              </div>

              <div className="item event-card_venue">
                <div className="image-container_venue">
                  <img
                    src="./assets/img/eventify/venue4.jpeg"
                    className="event-image_venue"
                  />
                </div>
                <h5 className="contain_venue_name">Silverstone Circuit</h5>
              </div>

              <div className="item event-card_venue">
                <div className="image-container_venue">
                  <img
                    src="./assets/img/eventify/venue5.jpeg"
                    className="event-image_venue"
                  />
                </div>
                <h5 className="contain_venue_name">Kalinga Stadium </h5>
              </div>

              <div className="item event-card_venue">
                <div className="image-container_venue">
                  <img
                    src="./assets/img/eventify/venue6.jpeg"
                    className="event-image_venue"
                  />
                </div>
                <h5 className="contain_venue_name">Twickenham Stadium </h5>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Venue;
